import React, { useEffect, useState } from 'react';
import { disableTealiumRoleKey } from 'models/preferences/PreferencesMapping';
import { useUserHasFeature } from '../../services/preferenceData';
import { addConsentPreferenceSubmitEventListener, initializeGAAndMatomo } from '../../backbone/utils/AnalyticsUtil';
import styles from './Consent.module.css';

/**
 * The cookie consent banner
 */
const Consent = () => {
    const [consentScriptLoaded, setConsentScriptLoaded] = useState(false);

    const { isSuccess: isFetchPreferenceRoleSuccess, isAvailable: isTealiumDisabled } = useUserHasFeature(
        disableTealiumRoleKey
    );

    useEffect(() => {
        loadConsentScript();
    }, []);

    useEffect(() => {
        if (consentScriptLoaded) {
            // add the event listener immediately after the TrustArc script being loaded
            addConsentPreferenceSubmitEventListener();
        }
    }, [consentScriptLoaded]);

    useEffect(() => {
        if (consentScriptLoaded && isFetchPreferenceRoleSuccess) {
            /** Initialize Google Tag (GA4) and Matomo after the TrustArc script is loaded and add cookie 'notice_behavior' for consent requirement */
            initializeGAAndMatomo(isTealiumDisabled);
        }
    }, [consentScriptLoaded, isFetchPreferenceRoleSuccess, isTealiumDisabled]);

    const loadConsentScript = () => {
        const script = document.createElement('script');
        // To force the banner to display for testing purposes, add &country=gb to the end of the link below
        script.src =
            'https://consent.trustarc.com/notice?domain=connect.garmin.com&c=cookie_preferences&js=nj&noticeType=bb&gtm=1&text=true';
        script.onload = () => {
            setConsentScriptLoaded(true);
        };
        document.body.appendChild(script);
    };

    const renderBanner = () => {
        // Per TrustArc documentation, this ID must be "consent_blackbar" so
        // that the div gets filled by the cookie consent banner
        return <div id="consent_blackbar" className={styles.consentBar} />;
    };

    return <div id="consent">{consentScriptLoaded ? renderBanner() : ''}</div>;
};

export default Consent;
